import {
    AUTHENTICATE_USER_STARTED,
    AUTHENTICATE_USER_SUCCESS,
    AUTHENTICATE_USER_FAILURE,
    FORGOT_PASSWORD_STARTED,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    UPDATE_PASSWORD_STARTED,
    UPDATE_PASSWORD_SUCCESS,
    UPDATE_PASSWORD_FAILURE,
    RESET_PASSWORD_STARTED,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    CANCEL_ACTIVATE_ACCOUNT,
    LOGOUT_ALL_USER,
    LOGOUT,
    LOGOUT_ADMIN,
    REMOVE_ERROR_MESSAGE
} from "../../constants/salon-account/authenticate";
import API from "../../../utils/API/API";


export const cancelActivation = () => {
    API.post("/auth/refresh/cancel-activation");
    return {
        type: CANCEL_ACTIVATE_ACCOUNT,
    }
}
export const authenticateUser = (user) => {
    return (dispatch) => {
        dispatch(authenticateUserStarted());
        const email = user.email;
        const password = user.password;
        API.post(`/login`, {
            email,
            password,
        })
            .then((res) => {
                dispatch(authenticateUserSuccess(res.data));
            })
            .catch((err) => {
                dispatch(authenticateUserFailure(err.message));
            });
    };
};

const authenticateUserStarted = () => ({
    type: AUTHENTICATE_USER_STARTED,
});

const authenticateUserSuccess = (data) => ({
    type: AUTHENTICATE_USER_SUCCESS,
    payload: {
        data: data,                           // res.data only
    },
});

const authenticateUserFailure = (error) => ({
    type: AUTHENTICATE_USER_FAILURE,
    payload: { error },
});

export function logout() {
    API.post("/auth/refresh/logout");
    return { type: LOGOUT, payload: null };
}

export function logoutAdmin() {

    API.post("/api/logoutAdmin");
    return { type: LOGOUT_ADMIN, payload: null };
}

export function logout_all_user() {
    API.post("/auth/refresh/logout-all-user");
    return { type: LOGOUT_ALL_USER, payload: null };
}

export const resetPassword = (token, password) => {
    return (dispatch) => {
        dispatch(resetPasswordStarted());
        API.post(`/api/reset-password`,
            { token, password })
            .then((res) => {
                dispatch(resetPasswordSuccess());
            })
            .catch((err) => {
                catchError(err, dispatch, resetPasswordFailure)
            }).finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
}

const resetPasswordStarted = () => ({
    type: RESET_PASSWORD_STARTED,
});

const resetPasswordSuccess = () => ({
    type: RESET_PASSWORD_SUCCESS,
});

const resetPasswordFailure = (error) => ({
    type: RESET_PASSWORD_FAILURE,
    payload: { error },
});

export const forgotPassword = (email) => {
    return (dispatch) => {
        dispatch(forgotPasswordStarted());
        API.post(`/forgot-password`,
            email)
            .then((res) => {
                dispatch(forgotPasswordSuccess());
            })
            .catch((err) => {
                dispatch(forgotPasswordFailure(err.message));
            }).finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 3000);
            });
    };

}



const forgotPasswordStarted = () => ({
    type: FORGOT_PASSWORD_STARTED,
});

const forgotPasswordSuccess = () => ({
    type: FORGOT_PASSWORD_SUCCESS,
});

const forgotPasswordFailure = (error) => ({
    type: FORGOT_PASSWORD_FAILURE,
    payload: { error },
});

export const updatePassword = (password) => {
    return (dispatch) => {
        dispatch(updatePasswordStarted());
        API.patch(`/update-password`,
            password)
            .then((res) => {
                dispatch(updatePasswordSuccess(res.data));
            })
            .catch((err) => {
                catchError(err, dispatch, updatePasswordFailure);
            }).finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };

}

const updatePasswordStarted = () => ({
    type: UPDATE_PASSWORD_STARTED,
});

const updatePasswordSuccess = () => ({
    type: UPDATE_PASSWORD_SUCCESS,
});

const updatePasswordFailure = (error) => ({
    type: UPDATE_PASSWORD_FAILURE,
    payload: { error },
});


const logoutUser = () => ({
    type: LOGOUT
})


const removeErrorMessage = () => ({
    type: REMOVE_ERROR_MESSAGE,
})


//Handle catch error
//logout use when unauthorized
//display error message and remove message after 3 seconds
const catchError = (error, dispatch, nextFunction) => {
    var message = error.message
    if (error.response) {
        message = error.response.data.message
        if (error.response.status === 401) {
            dispatch(logoutUser());
        }
    }

    dispatch(nextFunction(message));
};